import { ActionModel, MessageType } from '@klant/conversational-connector/klant-conversational-connector.model';
import { ChoiceOptionModel, ChoicePromptMessageModel } from '@klant/conversational-connector/models/ChatMessage.model';

import { Component, computed, input, output, signal } from '@angular/core';

@Component({
    selector: 'message-choice-prompt',
    templateUrl: './message-choice-prompt.component.html',
    standalone: false
})
export class MessageChoicePromptComponent {
    public sendAction = output<ActionModel>();

    public isLastMessage = input<boolean>(false);
    public occurredAt = signal<number>(0);
    public isSelected = signal<boolean>(false);
    public showAvatar = signal<boolean>(false);
    public messageChoicePrompt = signal<ChoicePromptMessageModel>(null);

    public showChoiceOptionsSig = computed(() => {
        return this.isLastMessage() && !this.isSelected();
    });

    public onChoiceOptionSelected(choiceOption: ChoiceOptionModel): void {
        const action: ActionModel = {
            messageType: MessageType.PICK_CHOICE_ACTION,
            originMessage: this.messageChoicePrompt().id,
            choiceOptionId: choiceOption.id,
            text: choiceOption.text
        };

        this.sendAction.emit(action);
        this.isSelected.set(true);
    }
}
